import { render, staticRenderFns } from "./PlotHeader.vue?vue&type=template&id=354ec356"
import script from "./PlotHeader.vue?vue&type=script&lang=js"
export * from "./PlotHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports